'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.default = function (app) {
  app.provider('aMap', function () {

    var self = this;

    self.webKey = '';
    self.webServiceKey = '';
    self.mapScriptUrl = '';

    self.$get = function ($q, $ionicPlatform, $timeout, $rootScope, $http) {

      var _res = {
        location: {
          longitude: '',
          latitude: '',
          city: '',
          address: '',
          speed: 0,
          province: '',
          district: ''
        },
        EVENTS: {
          /**
           * 定位成功
           */
          locationSuccess: 'aMap.locationSuccess',
          /**
           * 位置移动
           */
          locationChange: 'aMap.locationChange',
          /**
           * 速度变化
           */
          speedChange: 'aMap.speedChange',
          /**
           * 定位失败
           */
          locationFailed: 'aMap.locationFailed'
        }
      };

      $ionicPlatform.ready(function () {
        if (window.cordova) {
          window.plugins && window.plugins.aMapLocationPlugin.getCurrentPosition(function (result) {
            _res.location.longitude = result.longitude;
            _res.location.latitude = result.latitude;
            $rootScope.$emit(_res.EVENTS.locationSuccess, result);
          }, function (result) {
            $rootScope.$emit(_res.EVENTS.locationFailed, result);
            console.log((0, _stringify2.default)(result));
          });
          window.plugins && window.plugins.aMapLocationPlugin.watchPosition(function (result) {
            _res.location.longitude = result.longitude;
            _res.location.latitude = result.latitude;
            _res.location.speed = result.speed;
            _res.location.address = result.address;
            _res.location.province = result.province;
            _res.location.city = result.city;
            _res.location.district = result.district;
            //getSpeed(result);
            //jAlert.showOnce({message: JSON.stringify(_res.location)});
            $rootScope.$emit(_res.EVENTS.locationChange, result);
          }, function (result) {
            $rootScope.$emit(_res.EVENTS.locationFailed, result);
            console.log((0, _stringify2.default)(result));
          }, 10000);
        }
      });

      var loadMapDeferred = void 0;

      _res.loadMap = function () {
        if (!loadMapDeferred) {
          loadMapDeferred = $q.defer();
          if (window.AMap && window.AMap.Map) {
            loadMapDeferred.resolve();
          } else {
            var s = document.createElement('script');
            s.src = self.mapScriptUrl;
            s.onload = function () {
              $timeout(function () {
                if (window.AMap && window.AMap.Map) {
                  loadMapDeferred.resolve();
                } else {
                  loadMapDeferred.reject();
                }
              }, 100);
            };
            s.onerror = function () {
              loadMapDeferred.reject({ message: '加载地图失败' });
            };
            document.head.appendChild(s);
          }
        }
        return loadMapDeferred.promise;
      };

      _res.autocomplete = function (callbcak) {
        self.loadMap().then(function () {
          AMap.service(['AMap.Autocomplete'], function () {
            var placeSearch = new AMap.Autocomplete({ //构造地点查询类
              pageSize: 10,
              pageIndex: 1,
              extensions: 'all'
            });
            callbcak(placeSearch);
          });
        });
      };

      _res.placeSearch = function (options, callbcak) {
        self.loadMap().then(function () {
          AMap.service(['AMap.PlaceSearch'], function () {
            var placeSearch = new AMap.PlaceSearch({ //构造地点查询类
              pageSize: options && options.pageSize || 10,
              pageIndex: options && options.pageIndex || 1,
              city: options && options.city || '',
              extensions: options && options.extensions || 'all'
              //type: '公司企业'
            });
            callbcak(placeSearch);
          });
        });
      };

      _res.geocoder = function (options, callbcak) {
        self.loadMap().then(function () {
          AMap.service(['AMap.Geocoder'], function () {
            var geocoder = new AMap.Geocoder({ //构造地点查询类
              pageSize: 10,
              radius: 1000,
              extensions: 'all'
            });
            callbcak(geocoder);
          });
        });
      };

      /**
       * 获取当前用户的速度
       * @param {Array} destination
       */
      _res.getSpeed = function (destination) {
        return _res.getDistance([_res.location.longitude, _res.location.latitude], [destination.longitude, destination.latitude]).then(function (result) {
          if (_res.location.longitude === destination.longitude && _res.location.latitude === destination.latitude) {
            $rootScope.$emit(_res.EVENTS.speedChange, '0');
          } else {
            if (result) {
              var speed = (0, _data.toFixed)(result.distance / result.duration * 3.6, 2) + '公里/小时';
              _res.location.speed = speed;
              $rootScope.$emit(_res.EVENTS.speedChange, speed);
            }
          }
        }, function (data) {
          throw { message: data.message };
        });
      };

      /**
       * 获取地图坐标
       * @param {Array} addresses
       */
      _res.getGeographic = function (addresses) {
        if ((0, _objectType.isString)(addresses)) {
          addresses = [addresses];
        }
        if (!(0, _objectType.isArray)(addresses)) {
          var deferred = $q.defer();
          $timeout(function () {
            deferred.reject({ message: '输入参数错误' });
          }, 100);
          return deferred.promise;
        }
        return $http.get('http://restapi.amap.com/v3/geocode/geo', {
          params: {
            key: self.webServiceKey,
            address: addresses.join('|'),
            batch: addresses.length > 1,
            type: 1
          }
        }).then(function (result) {
          result = result.data;
          var points = [];
          if (result.info === 'OK' && result.geocodes) {
            for (var i = 0, l = result.geocodes.length; i < l; i++) {
              var item = result.geocodes[i];
              var locations = item.location.split(',');
              points.push({
                address: item.formatted_address,
                addressCode: item.adcode,
                province: item.province,
                city: item.city,
                cityCode: item.citycode,
                district: item.district,
                street: item.street,
                streetNumber: item.number,
                level: item.level,
                longitude: locations[0],
                latitude: locations[1]
              });
            }
          }
          return points;
        }, function (data) {
          throw data.message;
        });
      };

      /**
       * 获取两个坐标之间的距离
       * @param {Array} origins
       * @param {Array} destination
       */
      _res.getDistance = function (origins, destination) {
        return $http.get('http://restapi.amap.com/v3/distance', {
          params: {
            key: self.webServiceKey,
            origins: origins.join(','),
            destination: destination.join(','),
            type: 1
          }
        }).then(function (result) {
          var d = {
            distance: '',
            duration: ''
          };
          if (result && result.data && result.data.results && result.data.results.length) {
            var f = result.data.results[0];
            d.distance = f.distance;
            d.duration = f.duration;
          }
          return d;
        }, function (data) {
          throw data.message;
        });
      };

      return _res;
    };

    self.$get['$inject'] = ['$q', '$ionicPlatform', '$timeout', '$rootScope', '$http'];

    return self;
  });
  return app;
};

require('angular');

require('ionic');

var _data = require('../../utils/data');

var _objectType = require('../../utils/objectType');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

; /**
   * 地图服务 高德
   */


//////////////////
// WEBPACK FOOTER
// ./src/lib/ionic1.x-common/services/aMap.js
// module id = 156
// module chunks = 0